interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "…") {
      pages.push("…");
    }
  }

  return (
    <div className="flex items-center justify-center gap-2 mt-10">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="h-10 px-3 flex items-center gap-1 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-background-300 disabled:hover:text-foreground-700 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={[
              "w-10 h-10 flex items-center justify-center rounded-md text-sm font-medium transition-colors cursor-pointer",
              p === page
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700",
            ].join(" ")}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="w-10 h-10 flex items-center justify-center text-foreground-400">
            {p}
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="h-10 px-3 flex items-center gap-1 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-background-300 disabled:hover:text-foreground-700 cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}